<div class="upsell-section">
  <div class="upsell-section__container mx-auto flex justify-center">
    <div class="upsell-section__wrapper px-4 w-full">
      @for (item of content; track $index; let i = $index) {
        @if (item.title && item.title.length > 0) {
          <div class="text-center md:text-left mb-4 uppercase" [innerHTML]="item.title"></div>
        }
        @for (block of item.blocks; track $index; let i = $index) {
          <div class="mb-4" [ngClass]="'upsell-section-inner-div-' + (i + 1)" [innerHTML]="block" ></div>
        }
      }
    </div>
  </div>
</div>